import request from '@/utils/request'


// 查询订单信息列表
export function listOrderOrder(query) {
  return request({
    url: '/order/order/list',
    method: 'get',
    params: query
  })
}

// 查询订单信息分页
export function pageOrderOrder(query) {
  return request({
    url: '/order/order/page',
    method: 'get',
    params: query
  })
}

// 查询订单信息详细
export function getOrderOrder(data) {
  return request({
    url: '/order/order/detail',
    method: 'get',
    params: data
  })
}

// 新增订单信息
export function addOrderOrder(data) {
  return request({
    url: '/order/order/add',
    method: 'post',
    data: data
  })
}

// 修改订单信息
export function updateOrderOrder(data) {
  return request({
    url: '/order/order/edit',
    method: 'post',
    data: data
  })
}

// 删除订单信息
export function delOrderOrder(data) {
  return request({
    url: '/order/order/delete',
    method: 'post',
    data: data
  })
}

// 导入发货信息
export function importData (data) {
  return request({
    url: '/orderItem/orderItem/importDeliver',
    method: 'post',
    data: data
  })
}

// 查询订单统计列表
export function getStatistics(data) {
  return request({
    url: '/order/order/statistics',
    method: 'get',
    params: data
  })
}

// 查询订单信息详细
export function getStatisticsList(data) {
  return request({
    url: '/order/order/statisticsList',
    method: 'get',
    params: data
  })
}

